export default "__VITE_ASSET__D$gGDoY0__"